import calculateSavingsTotalByTranType from "../savings/objects/calculate_savings_total_by_tran_type";
import insertAccountTotalAndBalanceFwd from "./insert_account_total_and_balance_fwd";
import addSavingsTaxTransactions from "./add_savings_tax_transactions";
import splitBalanceForwardTran from "./split_balance_forward_tran";

export const createTranTotalArrays = (savingTransData, savingsClass, gameYear, savingTranArr, currentPriceArr) => {

    let tranSort = 0;
    if (savingsClass === "bank"){
        tranSort = 1111;
    }else{
        tranSort = 2222;
    }
    if (!currentPriceArr){
        currentPriceArr = [];
    }
    let outputTotalByTypeArr = [];
    let savingsTypeTotalArr = [];
    const selectSavingTrans = savingTransData.filter(elem => elem.savingsClass === savingsClass);
    const selectDetailTrans = savingTranArr.filter(elem => elem.savingsClass === savingsClass);
    const balFwdTranArr = splitBalanceForwardTran(selectDetailTrans, "");
    let totalArr = 
        calculateSavingsTotalByTranType(selectSavingTrans, savingsClass, tranSort, balFwdTranArr, 
            currentPriceArr);
    totalArr.sort((a, b) => 
            ((a.savingsType + a.tranYear + a.tranType) > (b.savingsType + b.tranYear + b.tranType)) ? 1 : -1);
    const totalTranNotAllArr = totalArr.filter(elem => elem.tranYear !== "all");
    let totalTranArr = insertAccountTotalAndBalanceFwd(totalTranNotAllArr, savingsClass, gameYear);
    // split is required so that 'balance forward' transaction amounts don't mess up the total balance for 'all'
    const totalTranAllArr = totalArr.filter(elem => elem.tranYear === "all");
    const totalTranAllArrNew = insertAccountTotalAndBalanceFwd(totalTranAllArr, savingsClass, gameYear);
    totalTranArr = totalTranArr.concat(totalTranAllArrNew);
    let taxArr = addSavingsTaxTransactions(savingTransData, savingsClass);
    totalTranArr = totalTranArr.concat(taxArr);
    if (totalTranArr.length > 0){
        let totalByTypeArr = totalTranArr.filter(item => item.savingsType === "all");
        let imageURL = ""
        if (savingsClass === "bank"){
            imageURL = "Savings/savings.png";
        }else{
            imageURL = "Savings/saving401K.png";
        }
        const bankTotalByTypeObj = {accountType: savingsClass, imageURL: imageURL, 
            totalArr: totalByTypeArr};
        outputTotalByTypeArr.push(bankTotalByTypeObj);
        savingsTypeTotalArr = totalTranArr.filter(item => item.savingsType !== "all");
        savingsTypeTotalArr.sort((a, b) => ((a.typeSortValue + a.tranSort + b.tranNbr) 
            > (b.typeSortValue + b.tranSort +  b.tranNbr)) ? 1 : -1);
    }
    const returnObj = {totalByTypeArr: outputTotalByTypeArr, savingsTypeTotalArr: savingsTypeTotalArr};
    return returnObj;
}
export default createTranTotalArrays;